// @ts-nocheck
import {
  FETCH_FREELANCER_EVENT_FAILURE,
  FETCH_FREELANCER_EVENT_REQUEST,
  FETCH_FREELANCER_EVENT_SUCCESS,
  UPDATE_FREELANCE_EXPENSE_AND_TOTAL_REQUEST,
  UPDATE_FREELANCE_EXPENSE_AND_TOTAL_SUCCESS,
  UPDATE_FREELANCE_POSITION_RATE_SUCCESS,
} from "../../constants/event/freelancePositions";

const initialState = {
  list: [],
  isLoading: false,
};

const freelancePositionsReducer = (state = initialState, action) => {
  switch (action?.type) {
    // cate fetch all event freelancers
    case FETCH_FREELANCER_EVENT_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_FREELANCER_EVENT_SUCCESS:
      return {
        ...state,
        list: action?.payload?.freelancers,
        isLoading: false,
      };
    case FETCH_FREELANCER_EVENT_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    case UPDATE_FREELANCE_POSITION_RATE_SUCCESS: {
      const updatedPositionMap = {};
      action?.payload?.updatedPositions?.forEach((p) => {
        updatedPositionMap[p?.positionId] = p?.freelanceEcRate;
      });
      return {
        ...state,
        list: state?.list?.map((f) => ({
          ...f,
          positionDetails: f?.positionDetails?.map((p) => {
            if (updatedPositionMap?.[p?.Id]) {
              return {
                ...p,
                freelanceEcRate: updatedPositionMap?.[p?.Id],
              };
            } else {
              return p;
            }
          }),
        })),
      };
    }

    case UPDATE_FREELANCE_EXPENSE_AND_TOTAL_REQUEST: {
      const freelanceId = action?.payload;
      return {
        ...state,
        list: state?.list?.map((f) => {
          if (freelanceId?.userId == f?.id) {
            return {
              ...f,
              extraCompensation:
                freelanceId?.extraCompensation || f?.extraCompensation || 0,
              totalAmount: freelanceId?.totalAmount || f?.totalAmount || 0,
            };
          } else {
            return f;
          }
        }),
      };
    }

    default:
      return state;
  }
};

export default freelancePositionsReducer;
export { initialState };